<div
    class="review-chips-container"
    [ngClass]="{ 'display-chip' : displayChip }"
    (click)="actionClicked()"
    (keydown.enter)="actionClicked()"
    tabindex="0"
    >
    <div class="review-chip hmf-body-m hmf-px-xs hmf-py-xxxs hmf-display-inline-flex hmf-align-items-center hmf-round-radius" [ngClass]="{ 'review-chips--active': isSelected }">
        {{ label }}
        <span *ngIf="displayCancelSign" class="hmf-pl-xs">
            <homefield-icon class="review-chip-svg" width="20px" height="20px" name="sign-cancel"></homefield-icon>
        </span>
    </div>
</div>